import { component } from "picoapp";
import { getVariantLink } from "../lib/utils";

export default component(async (node, context) => {
  const [
    { default: KeenSlider },
    { useFilter, useUnveil, useFade, useNav, useAriaHidden },
  ] = await Promise.all([
    import("keen-slider"),
    import("../lib/keen-slider"),
    import("keen-slider/keen-slider.min.css"),
  ]);

  const desktopSliderElement = node.querySelector("[data-slider]");
  const mobileSliderElement = node.querySelector("[data-slider-mobile]");
  const mobileTooltipSliderElement = node.querySelector(
    "[data-tooltip-slider-mobile]"
  );
  const mobileTooltipPrevElement = node.querySelector(
    "[data-tooltip-mobile-prev]"
  );
  const mobileTooltipNextElement = node.querySelector(
    "[data-tooltip-mobile-next]"
  );
  const mobileTooltipElement = node.querySelector("[data-mobile-tooltip]");
  const preselectedId = node.dataset.preselectedVariantId;

  // Handle component form select
  const options = node.querySelectorAll('input[type="radio"]');
  options.forEach((optionElement) => {
    optionElement.addEventListener("click", function (e) {
      const selectedVariantId = e.target.dataset.vid;
      const optionValue = e.target.value;
      const currentSelectedOption = node.querySelector(
        `input[type="radio"][value="${optionValue}"]`
      );
      const mainSelectedOption = document.querySelector(
        `[data-select-id="id"][value="${optionValue}"]`
      );
      const variantLink = getVariantLink(
        selectedVariantId,
        node.dataset.productHandle
      );
      document.querySelectorAll(".js-infographic-link").forEach((el) => {
        el.setAttribute("href", variantLink);
      });
      currentSelectedOption.checked = true;
      if (mainSelectedOption) {
        mainSelectedOption.checked = true;
      }
      handleClickColorSelector(selectedVariantId);

      const variantSelectedEvent = new CustomEvent(`variant-selected:id`, {
        detail: {
          product: node.dataset.productHandle,
          variant: selectedVariantId,
          options: null,
        },
      });
      window.dispatchEvent(variantSelectedEvent);
    });
  });

  // Sync main product form select
  window.addEventListener("variant-selected:id", (event) => {
    const { currentVariant } = context.getState();
    const { variant } = event.detail;
    if (parseInt(variant) === currentVariant.id) {
      return false;
    }

    const infographicOptionElement = node.querySelector(
      `input[data-vid="${variant}"]`
    );
    infographicOptionElement.checked = true;
    handleClickColorSelector(variant);
  });

  const desktopSlider = KeenSlider(
    desktopSliderElement,
    {
      defaultAnimation: {
        duration: 300,
      },
      loop: true,
      drag: false,
      useFade: {
        duration: "0.1s",
        timingFunction: "ease-in-out",
      },
      created: (slider) => {
        slider.container.classList.remove("hide-init");
        const index = slider.slides.findIndex((s) => {
          return s.dataset.slideId === preselectedId;
        });
        slider.moveToIdx(index);
      },
    },
    [useFade, useAriaHidden]
  );

  const mobileSlider = KeenSlider(
    mobileSliderElement,
    {
      loop: true,
      useFilter: {
        dataAttribute: "data-slide-id",
        value: preselectedId,
      },
      useUnveil: {
        dataLazyImageSrc: "data-lazy-src",
        dataLazyImageSrcset: "data-lazy-srcset",
      },
      created: (slider) => {
        slider.container.classList.remove("hide-init");
      },
    },
    [useFilter, useUnveil, useAriaHidden]
  );

  // eslint-disable-next-line no-new
  new KeenSlider(
    mobileTooltipSliderElement,
    {
      defaultAnimation: {
        duration: 800,
      },
      loop: true,
      created: (slider) => {
        mobileTooltipPrevElement.addEventListener("click", () => {
          slider.prev();
        });

        mobileTooltipNextElement.addEventListener("click", () => {
          slider.next();
        });

        slider.container.classList.remove("hide-init");
      },
      slideChanged: (slider) => {
        const index = slider.track.details.rel;
        const slide = slider.slides[index];
        mobileTooltipElement.style.left = `${slide.dataset.tooltipX}%`;
        mobileTooltipElement.style.top = `${slide.dataset.tooltipY}%`;
      },
    },
    [useAriaHidden, useNav(mobileSlider)]
  );

  function handleClickColorSelector(variantId) {
    const desktopIndex = desktopSlider.slides.findIndex((s) => {
      return s.dataset.slideId === variantId;
    });
    desktopSlider.moveToIdx(desktopIndex);

    const mobileIndex = mobileSlider.track.details.rel;
    mobileSlider.options.useFilter.value = variantId;
    mobileSlider.emit("filter");
    mobileSlider.track.init(mobileIndex);
    mobileSlider.emit("applyAriaHidden");
  }
});
